import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
export default function AboutLoader() {
  return (
    <>
      <Stack spacing={1} className="pt-[20px]">
        <Skeleton variant="rectangle" height="10rem" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </Stack>
    </>
  );
}
